module.exports = __webpack_public_path__ + "static/media/bg_day.4fd39226.png";